import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useScrollToQuestion } from '@/hooks/useScrollToQuestion.js';

import { useCustomAnamnesisStore } from '@/store.js';

import { DropDown } from '../../Common/DropDown/DropDown.jsx';
import { useCustomAnamnesisStyles } from '../customAnamnesisStyles.js';
import { useDropdownQuestionStyles } from './QuestionTypesStyles.js';

const DropdownQuestion = ({
    question,
    answer,
    setAnswer,
    isSubQuestion = false,
    hideTitle = false,
    noMarginTop = false,
    required = false,
    requiredErrorMessage = undefined,
}) => {
    const { t } = useTranslation();
    const classes = useDropdownQuestionStyles();
    const customAnamnesisStyles = useCustomAnamnesisStyles();
    const highlightedQuestions = useCustomAnamnesisStore((state) => state.highlightedQuestions);
    const questionRef = useScrollToQuestion(question);
    const [showRequiredError, setShowRequiredError] = useState(false);

    const onChange = (value) => {
        setAnswer(value);

        if (value && highlightedQuestions[question.question_key[0].text]) {
            useCustomAnamnesisStore.setState({
                highlightedQuestions: {
                    ...highlightedQuestions,
                    [question.question_key[0].text]: false,
                },
            });
        }

        // Clear required error when user selects a value
        if (value && showRequiredError) {
            setShowRequiredError(false);
        }
    };

    const onClose = () => {
        if (required && !answer) {
            setShowRequiredError(true);
        }
    };

    return (
        <div
            ref={questionRef}
            data-testid={`question-${question.question_key[0].text}`}
            className={clsx(
                customAnamnesisStyles.defaultQuestion,
                required &&
                    !highlightedQuestions[question.question_key[0].text] &&
                    customAnamnesisStyles.requiredIndicator,
                highlightedQuestions[question.question_key[0].text] && customAnamnesisStyles.highlight
            )}
        >
            {!isSubQuestion && !hideTitle && (
                <Typography style={{ marginBottom: '1rem' }} className={classes.title}>
                    {question.title[0].text}
                </Typography>
            )}
            <DropDown
                type="default"
                data={answer}
                setData={(value) => onChange(value)}
                mainDataHeading={question.label[0].text}
                mainDataArray={question.dropdown_options}
                compulsory=""
                validateForm={onClose}
                noMarginTop={noMarginTop}
                required={required}
            />
            {showRequiredError && (
                <Typography className={classes.errorText}>{requiredErrorMessage || t('RequiredField')}</Typography>
            )}
        </div>
    );
};

export default DropdownQuestion;
